import React, {Component} from 'react';
import {Typography} from '@material-ui/core/';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles/index';
import NavigationIcon from '@material-ui/icons/AccountCircle';
// import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
    root: {
        width  : 280,
        padding: 24
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        width: '100%',
        paddingBottom: '-10'
    },
    dense: {
        marginTop: 16,
    },
    menu: {
        width: 200,
    },
});

class QuickPanelContent extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            email: '',
            password: ''
        };
    }
    
    // state = {
    //     email: null,
    //     password: null
    // };

    handleLoginButton = (event, data) => {
        // alert(this.state.email);

        fetch(localStorage.getItem('api_domain')+'/api/login',{
            method: 'POST',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({
                email: this.state.email,
                password: this.state.password
            })
        })
          .then(res => res.json())
              .then(
                (result) => {

                    // alert('testing');

                    //what happened after login process
                    // console.log(result.token);
                    localStorage.setItem('jwt_token', result.token);

                    fetch(localStorage.getItem('api_domain')+'/api/AuthPengguna?token='+localStorage.getItem('jwt_token'),{
                        method: 'GET'
                        // headers: {'Content-Type':'application/json'}
                    })
                    .then(res => res.json())
                        .then(
                        (result) => {
                            // console.log(result.user);
                            // alert(result.status);
                    
                            if(result.status === 'Token is Expired' || result.status === 'Authorization Token not found'){
                                localStorage.setItem('jwt_token', '');
                                localStorage.setItem('user', '');
                            }else{
                                localStorage.setItem('user', JSON.stringify(result.user));
                    
                            // console.log(localStorage.getItem('user'));                        
                            }

                            window.location.reload(); 
                    
                        })

                    // console.log(localStorage.getItem('jwt_token'));
                    
                }
              )

    }
    
    handleChange = name => event => {
        this.setState({
          [name]: event.target.value,
        });
    };

    render()
    {
        const { classes } = this.props;
        return (
            <form className={classes.container} noValidate autoComplete="off">
                <div style={{width: '100%', height: 80, background: 'white', color: '#434343', fontSize: 30, lineHeight: 1}}>
                    Masuk ke <b style={{fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', fontStyle: 'normal', fontWeight: 800, lineHeight: 1, fontSize: 30}}>BelajarBareng</b>
                </div>
                <TextField
                id="email"
                label="Username/Email"
                className={classes.textField}
                value={this.state.email}
                onChange={this.handleChange('email')}
                margin="normal"
                variant="outlined"
                />
                <TextField
                id="password"
                label="Password"
                className={classes.textField}
                type="password"
                onChange={this.handleChange('password')}
                autoComplete="current-password"
                margin="normal"
                variant="outlined"
                />
                <br/>
                <br/>
                <Button size="large" variant="contained" color="primary" className={classes.button} style={{width: '100%'}} onClick={this.handleLoginButton}>
                    <NavigationIcon className={classes.extendedIcon} />
                    <Typography style={{color: 'white', paddingLeft: '10px'}}>Masuk</Typography>
                </Button>
                <div style={{borderTop: '1px solid #ccc', marginTop: '20px', paddingTop: '20px', textAlign: 'left'}}>
                    <Typography style={{color: 'black', paddingLeft: '0px'}}>Belum punya akun BelajarBareng? Daftar!</Typography>
                </div>
                
            </form>
            
        )
    }
}

export default withStyles(styles, {withTheme: true})(QuickPanelContent);


// WEBPACK FOOTER //
// ./src/main/quickPanel/QuickPanelContent.js